<div class="edit-professor-modal">
   <div class="edit-professor-title">
      <h4>{{ 'app.edit_educator' | translate }}</h4>
   </div>
   <form [formGroup]="professorEdit">
      <div class="editimi-lendes-inputs">
         <div class="fieldContainer">
            <label for="professorName">{{ 'general.full_name' | translate }}</label>
            <div>
               <input id="professorName" type="text" formControlName="professorName" />
               <div *ngIf="
                     professorEdit.controls.professorName.touched &&
                     professorEdit.controls.professorName.invalid
                  " class="invalid">
                  {{ 'general.full_name' | translate }} {{ 'aria-labels.is_required' | translate }}
               </div>
               <div *ngIf="professorEdit.controls.professorName.errors?.minlength" class="invalid">
                  {{ 'general.educator' | translate }} {{ 'general.name_and_surname' | translate }} should contain at
                  least 3
                  characters!
               </div>
            </div>
            <label for="Email">{{ 'general.email' | translate }}</label>
            <div>
               <input id="Email" type="email" formControlName="professorEmail" />
               <!-- <div *ngIf="this.emailExists" class="invalid">
                  Email already exists, please try another one.*
               </div> -->
               <div *ngIf="
                     professorEdit.controls.professorEmail.touched &&
                     professorEdit.controls.professorEmail.invalid
                  " class="invalid">
                  {{ 'general.educator' | translate }} {{ 'login.email_required' | translate }}*
               </div>

               <div *ngIf="professorEdit.controls.professorEmail.errors?.email" class="invalid">
                  {{ 'app.educator_email_is_not_valid' | translate }}*
               </div>
            </div>

            <label for="EducatorId">{{ 'general.educator_index_id' | translate }}</label>
            <div>
               <input id="EducatorId" type="text" formControlName="professorEducatorID"
                  (ngModelChange)="validateEducatorId()" />
               <div *ngIf="this.educatorIdExists" class="invalid">
                  {{ 'app.educator_id_already_exists' | translate }}*
               </div>
            </div>

            <!-- <label for="PhoneNumber">{{ 'general.phone' | translate }}</label>
            <div>
               <input
                  id="PhoneNumber"
                  type="text"
                  formControlName="professorPhoneNumber"
               />
               <div
                  *ngIf="
                     professorEdit.controls.professorPhoneNumber.touched &&
                     professorEdit.controls.professorPhoneNumber.invalid
                  "
                  class="invalid"
               >
                  {{ 'general.educator' | translate }} {{ 'app.contact_number' | translate }} {{ 'general.end_date' | translate }}*
               </div>
               <div
                  *ngIf="
                     professorEdit.controls.professorPhoneNumber.errors
                        ?.minlength
                  "
                  class="invalid"
               >
                  {{ 'general.educator' | translate }} {{ 'app.contact_number' | translate }} should contain at least 6 numbers!
               </div>
            </div> -->

            <label for="title">{{ 'app.institution' | translate }}</label>
            <div>
               <select [formControl]="professorEdit.get('professorFaculty')" (change)="facultyChanged()">
                  <option value="-1" disabled>{{ 'general.select_institution' | translate }}</option>
                  <ng-container *ngFor="let faculty of faculties">
                     <option [value]="faculty.id">{{ faculty.name }}</option>
                  </ng-container>
               </select>
               <div *ngIf="
                     professorEdit.controls.professorFaculty.touched &&
                     professorEdit.controls.professorFaculty.invalid
                  " class="invalid">
                  {{ 'general.educator' | translate }} {{ 'app.institution' | translate }} {{ 'aria-labels.is_required'
                  | translate }}*
               </div>
            </div>

            <label for="title">{{ 'general.department' | translate }}</label>
            <div>
               <select formControlName="professorDepartment" [compareWith]="compareFn">
                  <option [ngValue]="null" disabled>{{ 'general.select_department' | translate }}</option>
                  <option value="" disabled>{{ 'app.department_to_be_added' | translate }}</option>
                  <ng-container *ngFor="let department of departments">
                     <option [ngValue]="department.id">{{ department.name }}</option>
                  </ng-container>
               </select>
               <div *ngIf="
                     professorEdit.controls.professorDepartment.touched &&
                     professorEdit.controls.professorDepartment.invalid
                  " class="invalid">
                  {{ 'general.educator' | translate }} {{ 'general.department' | translate }} {{
                  'aria-labels.is_required' | translate }}*
               </div>
            </div>

            <label for="prof">{{ 'general.subjects' | translate }}</label>
            <div>
               <ngx-select-dropdown [config]="this.config" [options]="this.subjects" [multiple]="true"
                  [formControl]="form['professorSubjects']"></ngx-select-dropdown>
               <div *ngIf="
                     professorEdit.controls.professorSubjects.touched &&
                     professorEdit.controls.professorSubjects.invalid
                  " class="invalid">
                  {{ 'general.educator' | translate }} {{ 'general.subjects' | translate }} {{ 'general.end_date' |
                  translate }}*
               </div>
            </div>
            <label for="title">{{ 'general.status' | translate }}</label>
            <div>
               <select formControlName="professorStatus">
                  <option value="1">{{ 'general.active' | translate }}</option>
                  <option value="0">{{ 'general.inactive' | translate }}</option>
               </select>
            </div>
            <label for="title">{{ 'app.role' | translate }}</label>
            <div>
               <select formControlName="role">
                  <option value="10" selected>Educator</option>
                  <option value="9">Student</option>
               </select>
            </div>
         </div>
         <div class="buttons">
            <!-- <a class="delete" (click)="delete()">{{ 'app.delete' | translate }}</a> -->
            <button class="btn-blue-filled-md"
               [disabled]="professorEdit.invalid || this.emailExists || this.educatorIdExists" [ngClass]="{
                  disable: professorEdit.invalid || this.emailExists || this.educatorIdExists
               }" type="submit" (click)="update()">
               {{ 'app.confirm' | translate }}
            </button>
            <button class="btn-secondary-md" (click)="cancel()">{{ 'general.cancel' | translate }}</button>
         </div>
      </div>
   </form>
</div>
<div id="overlay"></div>